import { Component, OnInit, Inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTabsModule } from '@angular/material/tabs'
import { MatTabsConfig, MAT_TABS_CONFIG } from '@angular/material/tabs';
import { MatIconModule } from '@angular/material/icon';
import { SocialSocialAIPlanTableComponentComponent } from "../../components/tables/social-publisher-commercial-model-table/social-publisher-commercial-model-table.component.component";
import { CoreService } from '../../services/core.service';
import { ActivatedRoute } from '@angular/router';
import { UsersTableComponent } from '../../components/tables/manage-account/users-table/users-table.component';
import { SocialAiAdminSiteTableComponent } from '../../components/tables/manage-account/site-table/site-table.component';
import { SocialAiAdminRssFeedTableComponent } from '../../components/tables/social-ai-admin-rss-feed-table/social-ai-admin-rss-feed-table.component';
import { SocialAiAdminPlatformsTableComponent } from '../../components/tables/social-ai-admin-platforms-table/social-ai-admin-platforms-table.component';
import { SocialAiAdminManageVideoTemplateTableComponent } from '../../components/tables/social-ai-video-template-table/social-ai-video-template-table.component';

@Component({
  selector: 'app-companysettings',
  standalone: true,
  imports: [
    CommonModule,
    MatTabsModule,
    MatIconModule,
    SocialAiAdminSiteTableComponent,
    UsersTableComponent,
    SocialSocialAIPlanTableComponentComponent,
    SocialAiAdminRssFeedTableComponent,
    SocialAiAdminPlatformsTableComponent,
    SocialAiAdminManageVideoTemplateTableComponent
  ],
  templateUrl: './companysettings.component.html',
  styleUrl: './companysettings.component.scss',
  providers: [
    {
      provide: MAT_TABS_CONFIG,
      useValue: {
        animationDuration: '900ms',
        disablePagination: false,
      } as MatTabsConfig
    }
  ]
})
export class CompanySettingsComponent {

  companyData: any = [];
  companyID: any = [];

  tabs = [
    { name: 'Users', icon: 'person' },
    { name: 'Social Page/Site', icon: 'language' },
    { name: 'Platforms', icon: 'share' },
    { name: 'Post Category', icon: 'category' },
    { name: 'Video Templates', icon: 'movie' },
    { name: 'Publio Plan', icon: 'payments' }
  ];
  selectedIndex = 0;

  constructor(
    private coreService: CoreService,
    private route: ActivatedRoute
  ) { }

  ngOnInit(): void {
    this.route.paramMap.subscribe(params => {
      const id = params.get('id');
      this.companyID = id;
    });
    this.coreService.getData(`/company/getcompanydata/${this.companyID}`).subscribe(data => {
      this.companyData = data;
      this.companyData['Name'] = this.companyData['Name'];

    })
  }
}
